module.exports = __webpack_public_path__ + "img/18.ce955942.png";